import React from 'react'
import { Mail } from 'lucide-react'
import { SUPPORT_WORK_TYPE_COLORS } from 'utils/supportWorkTypeColors'

const Email = () => {
  return (
    <div
  style={{
    width: "23px",
    height: "20px",
    backgroundColor: SUPPORT_WORK_TYPE_COLORS.EMAIL,
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "3px",
  }}
>
  <Mail color="white" size={15.5} strokeWidth={2.25} />
</div>
  )
}

export default Email